var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2132 13.5315C27.536 13.5315 26.6389 13.5165 25.522 13.5165C22.7981 13.5165 20.5583 11.262 20.5583 8.5125V3.6885C20.5583 3.309 20.2553 3 19.8796 3H11.9454C8.24275 3 5.25 6.039 5.25 9.7635V25.926C5.25 29.8335 8.38533 33 12.2544 33H24.0694C27.7587 33 30.75 29.9805 30.75 26.253V14.2065C30.75 13.8255 30.4485 13.518 30.0712 13.5195C29.4371 13.524 28.6766 13.5315 28.2132 13.5315Z",
    fill: "url(#paint0_linear_3359_22934)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.126 3.85105C23.6775 3.38455 22.8945 3.70555 22.8945 4.35205V8.30755C22.8945 9.96655 24.261 11.3316 25.92 11.3316C26.9655 11.3436 28.4175 11.3466 29.6505 11.3436C30.282 11.3421 30.603 10.5876 30.165 10.1316C28.5825 8.48605 25.749 5.53705 24.126 3.85105Z",
    fill: "url(#paint1_linear_3359_22934)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.627 22.339C22.2435 22.339 22.7445 22.84 22.7445 23.4565C22.7445 24.073 22.2435 24.5725 21.627 24.5725H13.461C12.8445 24.5725 12.345 24.073 12.345 23.4565C12.345 22.84 12.8445 22.339 13.461 22.339H21.627ZM18.5383 14.8477C19.1548 14.8477 19.6558 15.3487 19.6558 15.9652C19.6558 16.5817 19.1548 17.0812 18.5383 17.0812H13.4608C12.8443 17.0812 12.3448 16.5817 12.3448 15.9652C12.3448 15.3487 12.8443 14.8477 13.4608 14.8477H18.5383Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3359_22934",
    x1: 18,
    y1: 3,
    x2: 18,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC31A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3359_22934",
    x1: 26.6308,
    y1: 3.62988,
    x2: 26.6308,
    y2: 11.3446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC31A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.2ccd077dea2acdf0e612cb57cfdf05a4.svg";
export { ForwardRef as ReactComponent };